enum AccountType {
  IBAN_BIC = 'IBAN_BIC',
  ACCOUNTNUMBER_BANKCODE = 'ACCOUNTNUMBER_BANKCODE'
}

export default AccountType
